import React, { useState } from "react";
import { Button, Form, Input, Select, Flex, Progress } from "antd";

const PrivateDomain = () => {
  const [form] = Form.useForm();

  return (
    <div>
      <h1>分发计划</h1>
      <Form
        name="basic"
        form={form}
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 20 }}
        initialValues={{ remember: true }}
        autoComplete="off"
      >
        <Form.Item
          label="作品ID"
          name="id"
          rules={[{ required: true, message: "请输入作品ID!" }]}
        >
          <Input placeholder="请输入作品ID" />
        </Form.Item>

        <Form.Item
          label="渠道"
          name="channel"
          rules={[{ required: true, message: "请选择渠道!" }]}
        >
          <Select placeholder="请选择渠道" allowClear>
            <Select.Option value="t1">捷途APP</Select.Option>
            <Select.Option value="t2">捷途小程序</Select.Option>
            <Select.Option value="t3">小红书</Select.Option>
            <Select.Option value="t4">微信</Select.Option>
            <Select.Option value="t5">抖音</Select.Option>
            <Select.Option value="t6">快手</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="阈值"
          name="threshold"
          rules={[{ required: true, message: "请选择渠道!" }]}
        >
          <Input placeholder="请输入阈值" />
        </Form.Item>

        <Form.Item
          label="投放次数"
          name="number"
          rules={[{ required: true, message: "请输入投放次数!" }]}
        >
          <Input placeholder="请填写" />
        </Form.Item>

        <Form.Item
          label="触达人群"
          name="tagesc"
          rules={[{ required: true, message: "请输入!" }]}
        >
          <Input placeholder="请输入" />
        </Form.Item>

        <Form.Item label="流量设置">
          <Flex wrap gap="middle" style={{ marginTop: 16 }}>
            <Progress
              type="dashboard"
              steps={8}
              percent={50}
              trailColor="rgba(0, 0, 0, 0.06)"
              strokeWidth={20}
            />
            <Progress
              type="circle"
              percent={100}
              steps={{ count: 5, gap: 7 }}
              trailColor="rgba(0, 0, 0, 0.06)"
              strokeWidth={20}
            />
          </Flex>
        </Form.Item>
        <div style={{ textAlign: "center" }}>
          <Button type="primary" style={{ marginTop: 48 }}>
            分发
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default PrivateDomain;
